import { Link } from 'react-router';

import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <section className="mx-auto max-w-md space-y-4 text-center">
      <h1 className="text-2xl font-bold">Seite nicht gefunden</h1>
      <p className="text-muted-foreground">Die angeforderte Seite existiert nicht.</p>
      <Button asChild variant="outline">
        <Link to="/">Zur Startseite</Link>
      </Button>
    </section>
  );
}
